import React, { FC } from 'react'
import { Heading, Stack, Text } from '@chakra-ui/react'

export type FeatureList = {
  title: string
  description: string
}

interface Props {
  features: FeatureList[]
}

const FeatureList: FC<Props> = ({ features }) => {
  return (
    <Stack mt="3rem" gap="8">
      {features.map((feature) => (
        <Stack key={feature.title} gap={2}>
          <Heading fontSize="1.125rem">{feature.title}</Heading>
          <Text color="#585858">{feature.description}</Text>
        </Stack>
      ))}
    </Stack>
  )
}

export default FeatureList
